import { render, staticRenderFns } from "./Website.vue?vue&type=template&id=407fec7a&scoped=true&"
import script from "./Website.vue?vue&type=script&lang=js&"
export * from "./Website.vue?vue&type=script&lang=js&"
import style0 from "./Website.vue?vue&type=style&index=0&id=407fec7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407fec7a",
  null
  
)

export default component.exports